var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"radio-button-group"},_vm._l((_vm.config),function({ label, value, checked, disabled, size }){return _c('RadioButton',_vm._b({key:value,staticClass:"radio-button-group__item",on:{"change":_vm.handleChange}},'RadioButton',{ value, label, checked, disabled, size, group: _vm.group },false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }